module.exports = __webpack_public_path__ + "img/nucleus.cca842b7.svg";